import ReducersFactory from '../../lib/reducers/ReducersFactory';

const participants = new ReducersFactory('participants', [])


export default participants.reducer